import React from "react";
import { Link } from "react-router-dom";

function CoffeeRules() {
  document.title = "SimWealth";
  return (
    <>
      <div className="bg bg-coffee-rules">
      <div data-aos="fade-rigth" className="container d-flex flex-column align-items-end justify-content-end vh-100 w-100">
            <div className="row d-flex justify-content-center align-items-end my-auto text-center w-35">
                <div className="bg-white rounded-border py-3 border border-4 border-dark">
                    <div className="col-12 heading-font mb-3">
                        <div type="button" className="btn btn-warning rounded-pill w-100 py-3 fs-4">Coffee Rules!</div>
                    </div>
                    <p>In all our simulations, we use the term “Purchasing Power” which means your ability to purchase more “goods & services” over time, a fancy way to mean improving your lifestyle, a measure of true wealth.</p>
                    <p>We use coffee to represent purchasing power.</p>
                    <p>The more coffee you can afford over time, the higher your purchasing power, the better your lifestyle.</p>
                    <p>Coffee is an easy visual to represent this concept. So… let’s load up on coffee.</p>

                    <Link to={'/instructions'} className="threeDButton btn fw-bold  w-75 ">
                    Show Me The Coffee!
                    </Link>
                </div>
            </div>
        </div>
      </div>
    </>
  );
}

export default CoffeeRules;
